import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@material-ui/core";
import React, { ReactElement } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  handleClose(valid: boolean): void;
  message: string;
  title: string;
}

function CarchupaDialog({ open, handleClose, message, title }: Props): ReactElement {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)} color="secondary">
          {t("Disagree")}
        </Button>
        <Button onClick={() => handleClose(true)} color="primary" autoFocus>
          {t("Agree")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CarchupaDialog;
